import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Message from 'components/Message';
import { ICONS } from 'constants/icons';

import messages from '../ModifierGroupEditor.messages';
import ConfirmSaveModal from './ConfirmSaveModal';

export const HIDDEN_GROUP_MODAL_NAME = 'HiddenGroupModal';

const HiddenGroupModal = ({ onConfirmSave }) => {
  const intl = useIntl();

  return (
    <ConfirmSaveModal
      label={intl.formatMessage(messages.hiddenGroupDialogLabel)}
      icon={ICONS.warningYellow}
      title={<Message message={messages.hiddenGroupTitle} />}
      cancelLabel={messages.hiddenGroupCancel}
      acceptLabel={messages.hiddenGroupAction}
      onConfirmSave={onConfirmSave}>
      <Message message={messages.hiddenGroupBody} />
    </ConfirmSaveModal>
  );
};

HiddenGroupModal.propTypes = {
  onConfirmSave: PropTypes.func,
};

export default HiddenGroupModal;
